import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Header } from "../../../components/header";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { Loading } from "../../../components/loading";
import { useCategory, useUpdateCategory } from "../hooks";
import { CategoryForm } from "../components";

type IUpdateCategory = {
  id: string;
};

export const UpdateCategory: React.FC = () => {
  const { id } = useParams<IUpdateCategory>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      navigate("/");
    }
  }, []);

  const { data, refetch } = useCategory(+id!);
  const { form, submit, loading } = useUpdateCategory({
    id: +id!,
    onCompleted: () => {
      refetch();
      toast.success("La catégorie a été modifiée avec succès");
    },
  });

  useEffect(() => {
    if (data?.category?.ok && data?.category?.result) {
      const { result } = data.category;
      form.setValue("name", result.name);
    }
  }, [data]);

  if (!data) {
    return <Loading />;
  }

  return (
    <>
      <Header
        title="Catégorie"
        subtitle={data?.category?.result?.name}
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/category/${id}`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="card">
          <CardHeader title="Modifier une catégorie" />
          <CategoryForm loading={loading} form={form} submit={submit} />
        </div>
      </div>
    </>
  );
};
